import { api } from '../lib/api-client';

// Authentication API
export const authApi = {
  // Ghana card verification
  verifyGhanaCard: (ghanaCardNumber) => {
    const formData = new FormData();
    formData.append('ghana_card_number', ghanaCardNumber);
    return api.post('/self-service/verify-ghanacard', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  // Create account after Ghana card verification
  createAccount: (data) => {
    const formData = new FormData();
    formData.append('verification_token', data.verification_token);
    formData.append('email', data.email);
    formData.append('phone', data.phone);
    formData.append('password', data.password);
    formData.append('c_password', data.c_password);
    return api.post('/self-service/create-account', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  // OTP verification — backend accepts only otp_ref + otp
  verifyOtp: (data) => {
    const formData = new FormData();
    formData.append('otp_ref', data.otp_ref);
    formData.append('otp', data.otp);
    // Let axios set Content-Type automatically for FormData
    return api.post('/self-service/verify-otp', formData);
  },

  // OTP verification for password reset — backend accepts only otp_ref + otp
  verifyResetOtp: (data) => {
    const formData = new FormData();
    formData.append('otp_ref', data.otp_ref);
    formData.append('otp', data.otp);
    // Let axios set Content-Type automatically for FormData
    return api.post('/self-service/verify-reset-otp', formData);
  },

  // Login (Email Address or Phone Number)
  login: (credentials) => {
    const formData = new FormData();
    formData.append('email_or_phone', credentials.email_or_phone);
    formData.append('password', credentials.password);
    return api.post('/self-service/login', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
    
  verifyEmail: (data) =>
    api.post('verify-email', data),

  // (Removed old verifyOtp, now handled by new self-service/verify-otp above)

  createPassword: (data) => 
    api.post('create-password', data),
    
  forgotPassword: ({ email_or_phone }) => {
    console.log('forgotPassword called with:', email_or_phone);
    const formData = new FormData();
    formData.append('email_or_phone', email_or_phone);
    console.log('FormData created, posting to self-service/forgot-password');
    // Let axios set Content-Type automatically for FormData
    return api.post('self-service/forgot-password', formData).then(response => {
      console.log('forgotPassword API response:', response);
      return response;
    }).catch(error => {
      console.log('forgotPassword API error:', error);
      throw error;
    });
  },
    
  resetPassword: (data, token) => {
    const config = token ? {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    } : {};
    return api.post('reset-password', data, config);
  },
    
  refreshToken: (tokenValue) => 
    api.post('token/refresh', { tokenValue }),
    
  resendVerification: (email) => 
    api.post('resend-verification', { email }),
    
  logout: () => 
    api.post('logout'),
    
  getProfile: () => 
    api.get('profile'),
    
  updateProfile: (data) => 
    api.put('profile', data),
    
  changePassword: (data) => 
    api.post('change-password', data),

  // Resend OTP — backend accepts only otp_ref
  resendOtp: (otpRef) => {
    const formData = new FormData();
    formData.append('otp_ref', otpRef);
    return api.post('/self-service/resend-otp', formData);
  },
  // Delete account
  deleteAccount: () => api.delete('delete-account'),
};
